import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-report",
  "use": "icon-report-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-report\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" d=\"M14 12v2H5v-2h9zM3 12v2H1v-2h2zm11-5v2H5V7h9zM3 7v2H1V7h2zm11-5v2H5V2h9zM3 2v2H1V2h2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol